// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/index'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
//import HotTable from 'vue-handsontable-official'
import './directives'
import global from './global/global'//全局
import './promission'//这里进行路由后台获取的模拟
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
// import routeMap from './router/router.js';
// const _import = require('./router/_import_' + process.env.NODE_ENV) //获取组件的方法
// import Layout from '@/components/public/layout' //Layout 是架构组件，不在后台返回，在文件里单独引入

Vue.use(ElementUI)
Vue.config.productionTip = false

require('es6-promise').polyfill()

// const filterAsyncRouter = function(asyncRouterMap) { //遍历后台传来的路由字符串，转换为组件对象
//   const accessedRouters = asyncRouterMap.filter(route => {
//     if (route.component) {
//       if (route.component === 'Layout') { //Layout组件特殊处理
//         route.component = Layout
//       } else {
//         route.component = _import(route.component)
//       }
//     }
//     if (route.children && route.children.length) {
//       route.children = filterAsyncRouter(route.children)
//     }
//     return true
//   })

//   return accessedRouters
// }



// let isFetchRemote = true;



// 根据路由设置标题
router.beforeEach((to, from, next) => {
  // const username = sessionStorage.getItem('username');
  // if(!username && to.path!=='/'){
  //   next({path: '/'});
  // }else if(isFetchRemote && to.path !== '/'){
  //   axios.post('/api/sysback/getMenuTreeByUserRole',Qs.stringify({})).then(res => {
  //     if(res.data.code==1){
  //       isFetchRemote = false;
  //       const menuData = res.data.data;
  //       localStorage.setItem('router', JSON.stringify(menuData))
  //       const routeData = filterAsyncRouter(menuData)
  //       // const routeData = formatRoutes(menuData);
  //       router.options.routes = routeData
  //       router.addRoutes(routeData)
  //       console.log(routeData)
  //       console.log('这里添加路由')
  //       global.antRouter = menuData //将路由数据传递给全局变量，做侧边栏菜单渲染工作
  //       console.log(to.path)
  //       next()
  //     }else{
  //       isFetchRemote = true
  //     }
  //   })
  // }else{
  //   next()
  // }

  /*路由发生改变修改页面的title */
  if(to.meta.title) {
    document.title = to.meta.title
  }
  next();

})

// 创建一个axios实例

var axios_instance = axios.create({
  // config里面有这个transformRquest，这个选项会在发送参数前进行处理。
  // 这时候我们通过Qs.stringify转换为表单查询参数
  transformRequest: [function (data) {
    data = Qs.stringify(data)
    return data
  }],
  // 设置Content-Type
  headers: {'Content-Type': 'application/x-www-form-urlencoded'},
})
// 添加响应拦截器
axios_instance.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  if(response.data.code=="-12"){
    ElementUI.Message.warning({message: '尚未登录,将跳转至登录页'});
    router.push(`/`)
  }else if(response.data.code=="-13"){
    ElementUI.Message.warning({message: response.config.url+'接口权限不足,请联系管理员'});
  }
  return response
}, function (error) {
  // 对响应错误做点什么
  if (error.response) {
    switch (error.response.status) {
      case 500:
        ElementUI.Message.error({message: '服务端发生异常,请联系超管'});
    }
  }
  return Promise.reject(error)
})

//设置默认请求连接开头
axios.defaults.baseURL = process.env.API_ROOT
Vue.use(VueAxios, axios_instance)

Vue.prototype.$global = global

Vue.prototype.$stringFormat = function stringFormat (formatted, args) {
  for (let i = 0; i < args.length; i++) {
    let regexp = new RegExp('\\{' + i + '\\}', 'gi')
    formatted = formatted.replace(regexp, args[i])
  }
  return formatted
}

String.prototype.replaceAll = function(s1,s2){
  return this.replace(new RegExp(s1,"gm"),s2);
}

String.prototype.format = function(args) {
  var result = this;
  if (arguments.length > 0) {
      if (arguments.length == 1 && typeof (args) == "object") {
          for (var key in args) {
              if (args[key] != undefined) {
                  var reg = new RegExp("({" + key + "})", "g");
                  result = result.replace(reg, args[key]);
              }
          }
      }
      else {
          for (var i = 0; i < arguments.length; i++) {
              if (arguments[i] != undefined) {
                  //var reg = new RegExp("({[" + i + "]})", "g");//这个在索引大于9时会有问题，谢谢何以笙箫的指出
                  var reg = new RegExp("({)" + i + "(})", "g");
                  result = result.replace(reg, arguments[i]);
              }
          }
      }
  }
  return result;
}

// 全局loading动画函数
Vue.prototype.openLoading = function() {
  const loading = this.$loading({           // 声明一个loading对象
    lock: true,                             // 是否锁屏
    text: '执行中',                         // 加载动画的文字
    spinner: 'el-icon-loading',             // 引入的loading图标
    background: 'rgba(0, 0, 0, 0.8)',       // 背景颜色
    target: '.main_scrollbar',       // **需要遮罩的区域，这里写要添加loading的选择器**
    fullscreen: false,
    customClass: 'loadingclass'             // **遮罩层新增类名，如果需要修改loading的样式**
  })
  setTimeout(function () {                  // 设定定时器，超时5S后自动关闭遮罩层，避免请求失败时，遮罩层一直存在的问题
    loading.close();                        // 关闭遮罩层
  },5000)
  return loading;
}


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js